export enum COMPLETION_STATUS {
  NOT_STARTED = "not_started",
  STARTED = "started",
  COMPLETED = "completed",
  DISABLED = "disabled"
}

/**
 * Alias for lesson-specific status comparisons.
 * Points to the same enum today — but if lesson statuses ever diverge
 * from term statuses, only this file needs to change.
 */
export import LESSON_STATUS = COMPLETION_STATUS;

/**
 * Alias for term-specific status comparisons.
 * Points to the same enum today — but if term statuses ever diverge
 * from lesson statuses, only this file needs to change.
 */
export import TERM_STATUS = COMPLETION_STATUS;
